import axios from 'axios';

import { FetchStatus } from '@powdr/constants';
import { getNodeApiDomain } from '@powdr/utils'; // Will add back in later

import { LIFT_TRAIL_REPORT_PENDING, LIFT_TRAIL_REPORT_SUCCESS, LIFT_TRAIL_REPORT_ERROR } from '../types';

export const getLiftTrailReport = () => async (dispatch, getState) => {
  const LiftTrailReportStates = getState().liftTrailReport.status;
  dispatch({
    type: LIFT_TRAIL_REPORT_PENDING,
    payload: [],
  });
  // If more than one component calls the same feed make sure we only make one request
  if (LiftTrailReportStates === FetchStatus.IDLE) {
    try {
      const res = await axios.get(`${getNodeApiDomain()}/dor/lift-trail-report?alphabetical=true`);

      dispatch({
        type: LIFT_TRAIL_REPORT_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: LIFT_TRAIL_REPORT_ERROR,
        payload: error,
      });
    }
  }
};
